import { Injectable } from '@angular/core';
import CustomStore, { ResolvedData } from 'devextreme/data/custom_store';
import { firstValueFrom, ReplaySubject } from 'rxjs';

import { MemberItemEntity } from './member-item.entity';
import { MemberListEntity } from './member-list.entity';

@Injectable()
export class DxGridProvider {
	public customStore: CustomStore | null = null;
	private readonly data$ = new ReplaySubject<MemberListEntity>(1);

	public updateData(list: MemberListEntity): void {
		this.data$.next(list);
	}

	public createCustomStore(): CustomStore {
		if (this.customStore) {
			return this.customStore;
		}

		this.customStore = new CustomStore({
			key: 'id',
			load: async (): Promise<ResolvedData<MemberItemEntity>> => {
				const list = await firstValueFrom(this.data$);
				const filteredData = list.elements.toList().toArray();
				return Promise.resolve({
					data: filteredData || [],
					totalCount: list.totalItemsCount,
				});
			},
		});

		return this.customStore;
	}
}
